<template>
  <div class="container mt-5">
    <CCard class="shadow border" :style="{ borderRadius: '20px', boxShadow: '0 8px 20px rgba(0, 0, 0, 0.15)' }">
      <CCardBody>
        <div class="text-center mb-4 mt-4">
          <h4 class="fw-bold">Student council member (Normal) Candidate Register</h4>
          <p class="mb-1">Upload JPG Image</p>
          <small class="text-danger fw-semibold">*1080x1080 px</small>
        </div>

        <CForm>
          <!-- Image Upload -->
          <CRow class="align-items-center mb-4">
            <CCol md="12" class="text-center mb-3">
              <img v-if="profilePreview" :src="profilePreview" alt="Profile Preview" class="img-thumbnail d-block mx-auto" style="max-height: 200px; object-fit: contain;" />
              <div class="text-danger mt-1" v-if="errors.profile">Profile image is required.</div>
            </CCol>
            <CCol md="9">
              <input type="text" class="form-control" placeholder="Profile Image File" :value="profileFileName" disabled />
            </CCol>
            <CCol md="3">
              <input type="file" ref="profileInput" class="d-none" accept="image/jpeg,image/png" @change="handleProfileSelect" />
              <button type="button" class="btn btn-outline-primary w-100" @click="triggerProfileUpload">Choose File</button>
            </CCol>
          </CRow>

          <!-- Personal Fields -->
          <CRow class="mb-4">
            <CCol md="6" class="mb-3">
              <input type="text" class="form-control" :class="{ 'is-invalid': errors.name }" placeholder="Name" v-model="form.name" disabled />
            </CCol>
            <CCol md="6" class="mb-3">
              <input type="text" class="form-control" placeholder="Student ID" v-model="form.studentID" disabled />
            </CCol>
            <CCol md="6" class="mb-3">
              <input type="text" class="form-control" placeholder="School" :value="schoolLabel" disabled />
            </CCol>

            <!-- Dynamic Major Dropdown -->
            <CCol md="6" class="mb-3">
              <select class="form-control" v-model="form.major" :class="{ 'is-invalid': errors.major }">
                <option disabled value="">Select Major</option>
                <option v-for="m in filteredMajors" :key="m._id" :value="m._id">{{ m.major_name }}</option>
              </select>
              <div class="invalid-feedback" v-if="errors.major">Please select a major</div>
            </CCol>

            <!-- More Fields -->
            <CCol md="6" class="mb-3">
              <input type="text" class="form-control" :class="{ 'is-invalid': errors.line }" placeholder="Line ID" v-model="form.line" />
              <div class="invalid-feedback" v-if="errors.line">{{ errors.line }}</div>
            </CCol>

            <CCol md="6" class="mb-3">
              <select class="form-control" :class="{ 'is-invalid': errors.gpaxtype }" v-model="form.gpaxtype">
                <option disabled value="">Select GPA Type</option>
                <option v-for="type in gpaxtypes" :key="type._id" :value="type._id">{{ type.gpaxtype_name }}</option>
              </select>
              <div class="invalid-feedback" v-if="errors.gpaxtype">{{ errors.gpaxtype }}</div>
            </CCol>

            <CCol md="6" class="mb-3">
              <input
                  type="number" step="0.01" min="0" max="4" class="form-control" :class="{ 'is-invalid': errors.gpax }" placeholder="GPAX" v-model="form.gpax" />
              <div class="invalid-feedback" v-if="errors.gpax">{{ errors.gpax }}</div>
            </CCol>

            <!-- Transcript Upload -->
            <CCol md="6">
              <CRow class="align-items-center">
                <CCol md="8">
                  <input type="text" class="form-control" placeholder="Transcript File" :value="transcriptFileName" disabled />
                </CCol>
                <CCol md="4">
                  <input type="file" ref="transcriptInput" class="d-none" accept="image/jpeg,image/png" @change="handleTranscriptSelect" />
                  <button type="button" class="btn btn-outline-primary w-100" @click="triggerTranscriptUpload">Choose File</button>
                </CCol>
                <CCol md="12" class="text-center mt-2">
                  <img v-if="transcriptPreview" :src="transcriptPreview" alt="Transcript Preview" class="img-thumbnail" style="max-height: 200px; object-fit: contain;" />
                  <div class="text-danger mt-1" v-if="errors.transcript">Transcript image is required.</div>
                </CCol>
              </CRow>
            </CCol>
          </CRow>

          <!-- Policy Section -->
          <CCardHeader class="fw-bold fs-5 mt-4">
            <h4>Write your policy here</h4>
          </CCardHeader>
          <CCardBody>
            <quill-editor v-model="form.policy" :options="editorOptions" :class="{ 'is-invalid': errors.policy }" style="min-height: 200px" />
            <div class="text-danger mt-1" v-if="errors.policy">{{ errors.policy }}</div>
          </CCardBody>

          <!-- Submit -->
          <div class="text-center mb-4">
            <CButton color="danger" size="lg" shape="pill" @click="submitForm" :disabled="isSubmitting">
              {{ isSubmitting ? 'Submitting...' : 'Submit' }}
            </CButton>
          </div>
        </CForm>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import api from '@/service/api.js'
import Vue from 'vue'
import VueQuillEditor from 'vue-quill-editor'
import Swal from 'sweetalert2'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

Vue.use(VueQuillEditor)

export default {
  data() {
    return {
      userEmail: '',
      profileFileName: '',
      transcriptFileName: '',
      profileFile: null,
      transcriptFile: null,
      profilePreview: '',
      transcriptPreview: '',
      gpaxtypes: [],
      allMajors: [],
      filteredMajors: [],
      schoolLabel: '',
      isSubmitting: false,
      form: {
        name: '',
        studentID: '',
        major: '',
        line: '',
        gpax: '',
        gpaxtype: '',
        policy: '',
        accountID: '',
        type: '',
        event: '686245fbb5e0dc05f8d093ff',
        year: new Date().getFullYear(),
        status: '685d149a2435685988f5f232'
      },
      errors: {},
      editorOptions: {
        placeholder: 'Type your policy here...',
        theme: 'snow'
      },
      departmentMajorMap: {
        "School of Applied Digital Technology": ["major3", "major4", "major5", "major6"],
        "School of Agro-Industry": ["major1", "major2"],
        "School of Cosmetic Science": ["major8", "major9"],
        "School of Health Science": ["major10", "major11", "major12"],
        "School of Integrative Medicine": ["major13", "major14", "major15", "major16"],
        "School of Law": ["major17", "major18"],
        "School of Liberal Arts": ["major19", "major20"],
        "School of Management": ["major21", "major22", "major23"],
        "School of Nursing": ["major25"],
        "School of Science": ["major26", "major27", "major28"],
        "School of Sinology": ["major29", "major30", "major31", "major32"],
        "School of Social Innovation": ["major33"],
        "School of Dentistry": ["major10"]
      }
    }
  },
  async mounted() {
    await this.loadGpaxtypes()
    await this.loadMajors()
    this.prefillFormFromAccount()
    this.loadCandidateType()
  },
  methods: {
    async loadGpaxtypes() {
      const res = await api.gpax('get')
      this.gpaxtypes = res.data.data || []
    },
    async loadMajors() {
      const res = await api.major('get')
      this.allMajors = res.data.data || []
    },
    async loadCandidateType() {
      const res = await api.type('get')
      const type = res.data.data.find(t => t.type_name.includes('Student council member (Normal)'))
      if (type) this.form.type = type._id
    },
    prefillFormFromAccount() {
      const user = JSON.parse(localStorage.getItem('user'))
      if (user) {
        this.userEmail = user.email
        this.form.name = user.name
        this.form.studentID = user.studentId
        this.form.accountID = user._id
        this.schoolLabel = user.department?.department_name || ''

        const majors = this.departmentMajorMap[this.schoolLabel] || []
        this.filteredMajors = this.allMajors.filter(m => majors.includes(m.major_code))
      }
    },
    triggerProfileUpload() {
      this.$refs.profileInput.click()
    },
    triggerTranscriptUpload() {
      this.$refs.transcriptInput.click()
    },
    handleProfileSelect(e) {
      const file = e.target.files[0]
      this.profileFile = file
      this.profileFileName = file.name
      this.profilePreview = URL.createObjectURL(file)
    },
    handleTranscriptSelect(e) {
      const file = e.target.files[0]
      this.transcriptFile = file
      this.transcriptFileName = file.name
      this.transcriptPreview = URL.createObjectURL(file)
    },
    isFormValid() {
      let valid = true
      this.errors = {}
      const required = ['name', 'studentID', 'line', 'gpax', 'gpaxtype', 'policy', 'accountID', 'type', 'event', 'major'];

      required.forEach(key => {
        if (!this.form[key]) {
          this.errors[key] = 'This field is required';
          valid = false;
        }
      });
      const gpax = parseFloat(this.form.gpax);
      if (isNaN(gpax) || gpax < 0 || gpax > 4) {
        this.errors.gpax = 'GPAX must be between 0.00 and 4.00';
        valid = false;
      }

      // ✅ Profile and Transcript are required
      if (!this.profileFile) {
        this.errors.profile = 'Profile image is required';
        valid = false;
      }

      if (!this.transcriptFile) {
        this.errors.transcript = 'Transcript image is required';
        valid = false;
      }
      return valid
    },
    async uploadImage(candidateId, file, type) {
      const formData = new FormData()
      formData.append('image', file)
      const method = type === 'profile' ? 'uploadCandidatePicture' : 'putCandidateTranscript'
      return api.candidate(method, { id: candidateId, formData })
    },
    async submitForm() {
      if (!this.isFormValid()) {
        Swal.fire('Missing Information', 'Please fill in all required fields.', 'error')
        return
      }

      this.isSubmitting = true
      try {
        const payload = {
          email: this.userEmail,
          line: this.form.line,
          gpax: parseFloat(this.form.gpax),
          type: this.form.type,
          gpaxtype: this.form.gpaxtype,
          policy: this.form.policy,
          event: this.form.event,
          year: this.form.year,
          major: this.form.major,
          status: this.form.status
        }

        const res = await api.candidate('post', payload)
        const candidateId = res?.data?.data?._id
        if (!candidateId) throw new Error('Candidate ID missing')

        // Upload images
        if (this.profileFile) await this.uploadImage(candidateId, this.profileFile, 'profile')
        if (this.transcriptFile) await this.uploadImage(candidateId, this.transcriptFile, 'transcript')

        await api.authenticated('update-major', {
          id: this.form.accountID,
          major: this.form.major
        })

        Swal.fire('Success', 'Your registration has been saved.', 'success')
            .then(() => this.$router.push({ name: 'Home' }))
      } catch (err) {
        console.error(err)
        Swal.fire('Error', err?.response?.data?.message || 'Something went wrong', 'error')
      } finally {
        this.isSubmitting = false
      }
    }
  }
}
</script>

<style scoped>
.is-invalid {
  border: 1px solid #dc3545 !important;
  border-radius: 0.375rem;
}
.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>
